module.exports = __webpack_public_path__ + "img/keyboard-arrow-left.1b577a91.svg";